var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer p-xl"},[_c('ul',[_c('li',[_c('a',{attrs:{"href":_vm.imprintLink,"target":"_blank"}},[_vm._v("Impressum")])]),_c('li',[_c('a',{attrs:{"href":_vm.privacyLink,"target":"_blank"}},[_vm._v("Datenschutz")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }